/**
 * GoJS License Configuration
 *
 * This file sets the GoJS license key globally. Import this file
 * before creating any GoJS diagrams to ensure the license is applied.
 *
 * Usage: import 'lib/gojs';
 */
import * as go from 'gojs';

go.Diagram.licenseKey =
  '28f846e1bb6458c511d35a25403d7efb0eab2e61cf814da2590517f4ed0a614727cee12f54868dc7d3fe49fb197490d0d9963e2f951e0239ee6481dc46e2d6fcb76373b115581789f70122c68bea2da9ac7071fb92b323f2d87e8ca0e2fbc2c955edf6804fcd0ebb2e7e0439057aa943e3fbdb2fff01994c3e3d9da2aebeab1efb38728c8cf451ddbf5f718cefecb24e757114dc25f963a01b';
